/**
 * External Dependencies
 */
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

/**
 * Component
 */
class Content extends Component {
  render() {
    return (
      <>
        <p className="display-4 mb-30">Page Not Found</p>
        <Link to="/" className="btn btn-brand" style={{ color: '#2b2b2b' }}>Back Home</Link>
      </>
    );
  }
}

export default connect(({ settings }) => (
  {
    settings,
  }
))(Content);
